// Marketing's words (BL-189), shared by AdsViews and the rows that draw ads on RowList: the ad platforms'
// names, what went to Google by kind, and an ad account's state.
import type { LabelKind } from './Label/Label.tsx';
import type { AdsStatusProps, ConversionsProps } from '../schemas.ts';

/** The ad platforms' names, as the office says them. */
export const PLATFORM_WORDS = { google_ads: 'Google Ads', microsoft_ads: 'Microsoft Ads (Bing)' } as const;

/** What went to Google, by kind. */
export const CONVERSION_WORDS: Record<ConversionsProps['conversions'][number]['kind'], string> = {
  lead: 'A lead call',
  quoted: 'Quoted',
  booked: 'Booked',
  completed: 'Completed',
};

/** An account's state as a word: failing red, working muted, not connected muted. */
export function accountState(a: AdsStatusProps['accounts'][number]): [string, LabelKind] {
  if (!a.connected) return ['Not connected', 'muted'];
  if (a.failing) return ['Failing', 'bad'];
  if (a.lastError) return ['Trying again', 'wait'];
  return [a.test ? 'Test account' : 'Working', 'muted'];
}
